<template>
  <div class="ad-statistics-page">
    <a-card bordered>
      <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 16px;">
        <!-- 日期选择 -->
        <a-form-item label="日期范围" prop="dateRange" style="margin-bottom: 0;">
          <a-range-picker
              v-model="dateRange"
              format="YYYY-MM-DD"
              :allowClear="false"
              style="width: 260px"
          />
        </a-form-item>

        <!-- 查询和重置按钮靠右 -->
        <div style="margin-left: auto; display: flex; gap: 8px;">
          <a-button type="primary" @click="handleQuery">
            <a-icon type="search" /> 查询
          </a-button>
          <a-button @click="resetQuery">
            <a-icon type="redo" /> 重置
          </a-button>
        </div>
      </div>

      <!-- 广告统计 -->
      <div style="display: flex; justify-content: space-between; margin-top: 24px;">
        <div class="stat-box" @click="showDrawer" style="margin-top: 16px">
          <a-statistic
              title="广告播放总次数"
              :value="totalPlayCount"
              value-style="color: #1890ff"
          />
        </div>
      </div>
    </a-card>
    <AdWelfareDrawer
        :visible.sync="drawerVisible"
        :date-range="dateRange"
    />
  </div>
</template>

<script>
import AdWelfareDrawer from './modules/AdWelfareDrawer.vue'
import {adWelfateStatistics} from '@/api/statistics/ad-series'
import moment from "moment/moment";

export default {
  name: 'AdWelfareStatistics',
  components: {AdWelfareDrawer},
  data() {
    return {
      advanced: true,
      drawerVisible: false,
      dateRange: [moment().startOf('day'), moment().endOf('day')],
      totalPlayCount: 0
    }
  },
  mounted() {
    this.dateRange = [moment().startOf('day'), moment()]
    this.adWelfateTotal()
  },
  methods: {
    adWelfateTotal() {
      if (this.dateRange.length !== 2) return
      const [start, end] = this.dateRange
      adWelfateStatistics({
        startDate: start.format('YYYY-MM-DD'),
        endDate: end.format('YYYY-MM-DD')
      }).then(res => {
        this.totalPlayCount = res.data || 0
      })
    },
    showDrawer() {
      this.drawerVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.adWelfateTotal()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        pageNum: 1,
        pageSize: 10
      }
      this.dateRange = [moment().startOf('day'), moment().endOf('day')]
      this.handleQuery()
    },
  }
}
</script>

<style scoped>
.stat-box {
  cursor: pointer;
  flex: 1;
  text-align: center;
  padding: 12px;
  transition: all 0.3s;
  border-radius: 4px;
}

.stat-box:hover {
  background: #f0f5ff;
  box-shadow: 0 0 5px rgba(24, 144, 255, 0.3);
}
</style>
